import { FileDownload } from "@mui/icons-material";
import {
  Box,
  CircularProgress,
  ClickAwayListener,
  Grow,
  ListItemIcon,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@mui/material";
import { useState } from "react";
import { toast } from "react-hot-toast";

import { saveAs } from "file-saver";
import { api } from "../../../services/api.v2";

export const ListMenu = ({ onClose,paramsConfig, ...props }) => {
  const [isLoadingDownloadCsv, setIsLoadingDownloadCsv] = useState(false);

  const handleDownloadCsv = async () => {
    setIsLoadingDownloadCsv(true);
    try {
      const response = await api.get(`/inventory/supplier-accounts-payable-xlsx`, {
        responseType: "blob", // Configura a resposta como um objeto Blob
        params: {
            codBase: paramsConfig.base,
            stores: paramsConfig.stores
        }
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Define o nome do arquivo
      const fileName = "arquivo.xlsx";
      saveAs(blob, fileName);
    } catch (error) {
      toast.error("Erro ao tentar baixar registros da pagina");
    } finally {
      setIsLoadingDownloadCsv(false);
    }
  };
  return (
    <Popper role={undefined} placement="bottom-start" transition {...props}>
      {({ TransitionProps, placement }) => {
        return (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom-start" ? "left top" : "left bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={onClose}>
                <MenuList
                  autoFocusItem={props.open}
                  id="composition-menu"
                  aria-labelledby="composition-button"
                >
                  <MenuItem
                    disabled={isLoadingDownloadCsv}
                    onClick={handleDownloadCsv}
                  >
                    {isLoadingDownloadCsv ? (
                      <Box mr={1.7} sx={{ display: "flex" }}>
                        <CircularProgress color="inherit" size={22} />
                      </Box>
                    ) : (
                      <ListItemIcon>
                        <FileDownload />
                      </ListItemIcon>
                    )}
                    Baixar
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        );
      }}
    </Popper>
  );
};
